module.exports = __webpack_public_path__ + "static/media/tyre-red-three3.1439e750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-three3.png
// module id = 342
// module chunks = 0